/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Client_ReassignedInputs */

const cs_enum_client_reassigned = /** @type {(inputs: Enum_Client_ReassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klient přeřazen`)
};

const en_enum_client_reassigned = /** @type {(inputs: Enum_Client_ReassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client reassigned`)
};

/**
* | output |
* | --- |
* | "Client reassigned" |
*
* @param {Enum_Client_ReassignedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_client_reassigned = /** @type {((inputs?: Enum_Client_ReassignedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Client_ReassignedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_client_reassigned(inputs)
	return cs_enum_client_reassigned(inputs)
});